import { render, staticRenderFns } from "./FreeBettingResult.vue?vue&type=template&id=7535d97c&scoped=true"
import script from "./FreeBettingResult.vue?vue&type=script&lang=js"
export * from "./FreeBettingResult.vue?vue&type=script&lang=js"
import style0 from "./FreeBettingResult.vue?vue&type=style&index=0&id=7535d97c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7535d97c",
  null
  
)

export default component.exports